'use strict';

import React from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/BackOffice'

import BillForm from '@/Form/BillForm'

import Link from '@Pure/Link'

export default PageWrapper(function NewBillPage (props)
{
	return (
		<Layout page_title="Nouvelle facture" history={ props.history }>

			<div className="page-content">

				<div className="u-flex u-content-end u-margin-bottom-20">
					<Link href="/gestion-des-factures"
						className="c-btn u-no-margin-top">
						Retour aux factures
					</Link>
				</div>

				<BillForm type="create" />

			</div>

		</Layout>
	);
});